export default __webpack_public_path__ + "static/media/FAQ_10_4.6e9615f0.png";